module.exports = __webpack_public_path__ + "static/media/2.question.1c29a43c.mp4";